import { investmentConstants } from "../_constants";
// USER's ACCOUNTS
export const updateUserAccounts = (accountNumbers) => ({
  type: investmentConstants.UPDATE_USER_ACCOUNTS,
  payload: accountNumbers,
});

export const resetInvestment = () => ({
  type: investmentConstants.RESET_INVESTMENT,
});

// INVESTMENT GENERAL
export const fetchActivedFundsStart = (accountNumbers) => ({
  type: investmentConstants.FETCH_ACTIVED_FUNDS_START,
  payload: accountNumbers,
});
export const fetchActivedFundsSuccess = (data) => ({
  type: investmentConstants.FETCH_ACTIVED_FUNDS_SUCCESS,
  payload: data,
});
export const fetchActivedFundsFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_ACTIVED_FUNDS_FAILURE,
  payload: errorMessage,
});

export const fetchAllFundsStart = (accountNumbers) => ({
  type: investmentConstants.FETCH_ALL_FUNDS_START,
  payload: accountNumbers,
});
export const fetchAllFundsSuccess = (data) => ({
  type: investmentConstants.FETCH_ALL_FUNDS_SUCCESS,
  payload: data,
});
export const fetchAllFundsFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_ALL_FUNDS_FAILURE,
  payload: errorMessage,
});

export const fetchAllFundCodesStart = () => ({
  type: investmentConstants.FETCH_ALL_FUND_CODES_START,
});
export const fetchAllFundCodesSuccess = (data) => ({
  type: investmentConstants.FETCH_ALL_FUND_CODES_SUCCESS,
  payload: data,
});
export const fetchAllFundCodesFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_ALL_FUND_CODES_FAILURE,
  payload: errorMessage,
});

// INVESTMENT PORTFOLIO
export const updatePortfoliosQueries = (queries) => ({
  type: investmentConstants.UPDATE_PORTFOLIOS_QUERIES,
  payload: queries,
});

export const fetchPortfoliosStart = (queries) => ({
  type: investmentConstants.FETCH_PORTFOLIOS_START,
  payload: queries,
});
export const fetchPortfoliosSuccess = (data) => ({
  type: investmentConstants.FETCH_PORTFOLIOS_SUCCESS,
  payload: data,
});
export const fetchPortfoliosFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_PORTFOLIOS_FAILURE,
  payload: errorMessage,
});

export const fetchNavPortfoliosStart = (data) => ({
  type: investmentConstants.FETCH_NAV_PORTFOLIO_START,
  payload: data,
});
export const fetchNavPortfoliosSuccess = (data) => ({
  type: investmentConstants.FETCH_NAV_PORTFOLIO_SUCCESS,
  payload: data,
});
export const fetchNavPortfoliosFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_NAV_PORTFOLIO_FAILURE,
  payload: errorMessage,
});

// PORTFOLIO STATISTICS
export const fetchPreviousReturnByAccountStart = (account) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_START,
  payload: account,
});
export const fetchPreviousReturnByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchPreviousReturnByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchPreviousReturnGraphByAccountStart = (payload) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_START,
  payload: payload,
});
export const fetchPreviousReturnGraphByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchPreviousReturnGraphByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchHistoryGraphByAccountStart = (payload) => ({
  type: investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_START,
  payload: payload,
});
export const fetchHistoryGraphByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchHistoryGraphByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchMonthlyReturnByAccountStart = (account) => ({
  type: investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_START,
  payload: account,
});
export const fetchMonthlyReturnByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchMonthlyReturnByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchProfitByAccountStart = (account) => ({
  type: investmentConstants.FETCH_PROFIT_BY_ACCOUNT_START,
  payload: account,
});
export const fetchProfitByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_PROFIT_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchProfitByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_PROFIT_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchVolatilityByAccountStart = (account) => ({
  type: investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_START,
  payload: account,
});
export const fetchVolatilityByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchVolatilityByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchMaxDrawdownByAccountStart = (account) => ({
  type: investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_START,
  payload: account,
});
export const fetchMaxDrawdownByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchMaxDrawdownByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

export const fetchDrawdownByAccountStart = (payload) => ({
  type: investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_START,
  payload: payload,
});
export const fetchDrawdownByAccountSuccess = (data) => ({
  type: investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_SUCCESS,
  payload: data,
});
export const fetchDrawdownByAccountFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_FAILURE,
  payload: errorMessage,
});

// Default Port stat
export const setDefaultPortStat = () => ({
  type: investmentConstants.SET_DEFAULT_PORT_STAT,
});

export const clearDefaultPortStat = () => ({
  type: investmentConstants.CLEAR_DEFAULT_PORT_STAT,
});
export const fetchLastDateOfAccountNumberSuccess = (date) => ({
  type: investmentConstants.FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_SUCCESS,
  payload: date,
});
export const fetchLastDateOfAccountNumberFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_FAILURE,
  payload: errorMessage,
});

// INVESTMENT ORDERS
export const deleteOrderRequestStart = (payload) => ({
  type: investmentConstants.DELETE_ORDER_REQUEST_START,
  payload: payload,
});
export const deleteOrderRequestSuccess = (data) => ({
  type: investmentConstants.DELETE_ORDER_REQUEST_SUCCESS,
  payload: data,
});
export const deleteOrderRequestFailure = (payload) => ({
  type: investmentConstants.DELETE_ORDER_REQUEST_FAILURE,
  payload,
});
export const fetchOrdersStart = (id) => ({
  type: investmentConstants.FETCH_ORDERS_START,
  payload: id,
});
export const fetchOrdersSuccess = (data) => ({
  type: investmentConstants.FETCH_ORDERS_SUCCESS,
  payload: data,
});
export const fetchOrdersFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_ORDERS_FAILURE,
  payload: errorMessage,
});
export const updateOrdersQueries = (queries) => ({
  type: investmentConstants.UPDATE_ORDERS_QUERIES,
  payload: queries,
});
export const clearOrderErrorMessage = () => ({
  type: investmentConstants.CLEAR_ORDER_ERROR_MESSAGE,
});

// INVESTMENT LOTS
export const updateLotQueries = (payload) => ({
  type: investmentConstants.UPDATE_LOT_QUERIES,
  payload: payload,
});

export const fetchLotsStart = (data) => ({
  type: investmentConstants.FETCH_LOTS_START,
  payload: data,
});
export const fetchLotsSuccess = (data) => ({
  type: investmentConstants.FETCH_LOTS_SUCCESS,
  payload: data,
});
export const fetchLotsFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_LOTS_FAILURE,
  payload: errorMessage,
});

export const fetchNavsLotsStart = (fundIds) => ({
  type: investmentConstants.FETCH_NAVS_LOTS_START,
  payload: fundIds,
});
export const fetchNavsLotsSuccess = (data) => ({
  type: investmentConstants.FETCH_NAVS_LOTS_SUCCESS,
  payload: data,
});
export const fetchNavsLotsFailure = (error) => ({
  type: investmentConstants.FETCH_NAVS_LOTS_FAILURE,
  payload: error,
});

// INVESTMENT BOOK
export const updateBookQueries = (payload) => ({
  type: investmentConstants.UPDATE_BOOK_QUERIES,
  payload: payload,
});

export const fetchBooksStart = () => ({
  type: investmentConstants.FETCH_BOOKS_START,
});
export const fetchBooksSuccess = (data) => ({
  type: investmentConstants.FETCH_BOOKS_SUCCESS,
  payload: data,
});
export const fetchBooksFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_BOOKS_FAILURE,
  payload: errorMessage,
});

// INVESTMENT HISTORIES
export const updateHistoriesQueries = (queries) => ({
  type: investmentConstants.UPDATE_INVESTMENT_HISTORIES_QUERIES,
  payload: queries,
});
export const fetchHistoriesStart = (page) => ({
  type: investmentConstants.FETCH_HISTORIES_START,
  payload: page,
});
export const fetchHistoriesSuccess = (data) => ({
  type: investmentConstants.FETCH_HISTORIES_SUCCESS,
  payload: data,
});
export const fetchHistoriesFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_HISTORIES_FAILURE,
  payload: errorMessage,
});

export const fetchHistoriesChangePage = (page) => ({
  type: investmentConstants.FETCH_HISTORIES_CHANGE_PAGE,
  payload: page,
});

// DIVIDEND
export const updateDividendQueries = (queries) => ({
  type: investmentConstants.UPDATE_DIVIDEND_QUERIES,
  payload: queries,
});

export const fetchDividendsStart = (data) => ({
  type: investmentConstants.FETCH_DIVIDENDS_START,
  payload: data,
});
export const fetchDividendsSuccess = (data) => ({
  type: investmentConstants.FETCH_DIVIDENDS_SUCCESS,
  payload: data,
});
export const fetchDividendsFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_DIVIDENDS_FAILURE,
  payload: errorMessage,
});

// INVESTMENT DCA
export const updateDCAQueries = (queries) => ({
  type: investmentConstants.UPDATE_INVESTMENT_DCA_QUERIES,
  payload: queries,
});
export const fetchDCAsStart = (queries) => ({
  type: investmentConstants.FETCH_DCAS_START,
  payload: queries,
});
export const fetchDCAsSuccess = (data) => ({
  type: investmentConstants.FETCH_DCAS_SUCCESS,
  payload: data,
});
export const fetchDCAsFailure = (errorMessage) => ({
  type: investmentConstants.FETCH_DCAS_FAILURE,
  payload: errorMessage,
});
export const deleteDCAOrderRequestStart = (payload) => ({
  type: investmentConstants.DELETE_DCA_ORDER_REQUEST_START,
  payload: payload,
});
export const deleteDCAOrderRequestSuccess = (data) => ({
  type: investmentConstants.DELETE_DCA_ORDER_REQUEST_SUCCESS,
  payload: data,
});
export const deleteDCAOrderRequestFailure = (errorMessage) => ({
  type: investmentConstants.DELETE_DCA_ORDER_REQUEST_FAILURE,
  payload: errorMessage,
});
export const clearDCAOrderErrorMessage = () => ({
  type: investmentConstants.CLEAR_DCA_ORDER_ERROR_MESSAGE,
});

// INVEST SEARCH
export const setInvestSearch = (isSearch) => ({
  type: investmentConstants.SET_INVEST_SEARCH,
  payload: isSearch,
});
